"use client";

import { cn } from "@/core/utils";
import { Download } from "lucide-react";
import type { Suggestion } from "../types";
import type { ActionsBarBlock } from "../schemas/blocks";

/**
 * Renderer do block `actions_bar` (ST-6 — Figma topo): ações de nível de resposta
 * (ex.: "Exportar relatório"). Clique reaproveita o fluxo de sugestão (onSuggestionClick).
 */

const ICONS: Record<string, typeof Download> = { download: Download };

function styleClass(style?: "solid" | "outline" | "ghost"): string {
  switch (style) {
    case "solid":
      return "bg-darkgray-900 text-white hover:bg-darkgray-800 border border-darkgray-900";
    case "ghost":
      return "text-darkgray-700 hover:bg-lightgray-100 border border-transparent";
    default: // outline
      return "bg-white text-darkgray-700 border border-lightgray-400 hover:bg-lightgray-100";
  }
}

export function ActionsBar({
  block,
  onSuggestionClick,
}: {
  block: ActionsBarBlock;
  onSuggestionClick?: (suggestion: Suggestion) => void;
}) {
  if (!block.actions.length) return null;
  return (
    <div
      className={cn(
        "flex flex-wrap gap-2",
        block.placement === "header" ? "justify-end" : "justify-start",
      )}
    >
      {block.actions.map((action) => {
        const Icon = action.icon ? ICONS[action.icon] : undefined;
        return (
          <button
            key={action.action}
            type="button"
            onClick={() =>
              onSuggestionClick?.({
                text: action.text,
                action: action.action,
                category: "actions_bar",
              })
            }
            className={cn(
              "inline-flex items-center gap-1.5 rounded-[10px] px-4 py-2 text-sm font-medium transition-colors",
              styleClass(action.style),
            )}
          >
            {Icon && <Icon className="h-4 w-4" aria-hidden />}
            {action.text}
          </button>
        );
      })}
    </div>
  );
}
